import { Card, Modal, notification, Spinner, Title } from "components/common";
import QuestionForm from "components/custom/question/questionForm";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useGetQuestionDetailQuery } from "../apis";
import {
  useAddQuestionMutation,
  useUpdateQuestionsMutation,
} from "features/script/api";
import { SCRIPT_QUESTIONS_LISTING } from "constants/app-paths";
import { useState } from "react";
import { generateUUID } from "pubnub";
import PageLayout from "components/common/pageLayout/pageLayout";

const AddEditQuestionPage = ({ inScriptForm = false, visible, setVisible }) => {
  const params = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ isShortQuestion: false });

  const {
    data: question,
    isLoading,
    error,
    refetch,
  } = useGetQuestionDetailQuery(
    { questionId: params?.id },
    { skip: !params?.id, refetchOnMountOrArgChange: true }
  );

  const [handleUpdate, { isLoading: updateLoading }] =
    useUpdateQuestionsMutation();
  const [addQuestion, { isLoading: submitLoading }] = useAddQuestionMutation();

  const validateForm = (data) => {
    if (!data?.scripts) {
      notification.error({ message: "Please select a script first!" });
      return false;
    } else if (!data?.explanation?.length) {
      notification.error({ message: "Please select an explanation first!" });
      return false;
    } else if (!data?.description?.length) {
      notification.error({
        message: "Please add description for the question!",
      });
      return false;
    } else if (!data?.correctAnswer?.length && !data?.isShortQuestion) {
      notification.error({ message: "Please select correct answer!" });
      return false;
    } else if (data?.isShortQuestion && !data?.shortAnswer) {
      notification.error({ message: "Please provide short answer!" });
      return false;
    }
    return true;
  };

  const updatedQuestion = async (data) => {
    let validate = validateForm(data);
    const body = {
      questionList: [
        {
          ...data,
          ...(data?.isShortQuestion && {
            isShortQuestion: true,
            correctAnswer: [
              data?.shortAnswer
                .replace(/<[^>]*>/g, "") // Remove HTML tags
                .replace(/&nbsp;/g, " ") // Replace &nbsp; with space
                .trim(),
            ],
            options: [
              {
                answerId: generateUUID(),
                answer: data?.shortAnswer
                  .replace(/<[^>]*>/g, "") // Remove HTML tags
                  .replace(/&nbsp;/g, " ") // Replace &nbsp; with space
                  .trim(),
              },
            ],
          }),
        },
      ],
      deletedQuestionIds: [],
    };
    if (validate) {
      const res = await handleUpdate(body);
      if (res) {
        if (res?.error) {
        } else {
          notification.success({ message: "Questions Updated Successfully!" });
          navigate(SCRIPT_QUESTIONS_LISTING);
        }
      }
    }
  };

  const createQuestion = async (data) => {
    let validate = validateForm(data);
    if (validate) {
      const res = await addQuestion({
        question: [
          {
            ...data,
            ...(data?.isShortQuestion && {
              isShortQuestion: true,
              correctAnswer: [
                data?.shortAnswer
                  .replace(/<[^>]*>/g, "") // Remove HTML tags
                  .replace(/&nbsp;/g, " ") // Replace &nbsp; with space
                  .trim(),
              ],
              options: [
                {
                  answerId: generateUUID(),
                  answer: data?.shortAnswer
                    .replace(/<[^>]*>/g, "") // Remove HTML tags
                    .replace(/&nbsp;/g, " ") // Replace &nbsp; with space
                    .trim(),
                },
              ],
            }),
          },
        ],
      });
      if (res?.error) {
        notification.error({ message: "Network Error" });
      } else {
        notification.success({ message: "Question Added Successfully!" });
        inScriptForm ? setVisible(false) : navigate(SCRIPT_QUESTIONS_LISTING);
      }
    }
  };

  const renderForm = () => {
    return (
      <QuestionForm
        inScriptForm={inScriptForm}
        onSubmit={(data) => {
          if (params?.id) {
            updatedQuestion(data);
          } else {
            createQuestion(data);
          }
        }}
        data={question?.[0]}
        editForm={!!params?.id}
        submitLoading={submitLoading || updateLoading}
        formData={formData}
        setFormData={setFormData}
      />
    );
  };

  return (
    <PageLayout>
      {params?.id && isLoading ? (
        <Spinner />
      ) : error ? (
        "Error"
      ) : !inScriptForm ? (
        <Card>{renderForm()}</Card>
      ) : (
        <Modal
          visible={visible}
          onCancel={() => {
            setVisible(false);
          }}
          onOk={() => createQuestion(formData)}
          title="Add Question"
          description="Add Question to Script and Link it with Explanation and Topic"
          width="1400px"
          okText="Add Question"
          destroyOnClose
        >
          {renderForm()}
        </Modal>
      )}
    </PageLayout>
  );
};

export default AddEditQuestionPage;
